import { EmptyState } from '@kerfjs/ui/empty-state';
import { List } from '@kerfjs/ui/list';
import { ValueTable, ValueTableRow } from '@kerfjs/ui/value-table';
import type { SafeHtml } from 'kerfjs';

import type { AnalysisProgress } from '../../../../../data/analysis-progress.js';
import { VerdictChip } from '../../../../verdict-chip.js';
import type { SummaryLine } from '../../summary-context.js';

/** Live per-line progress before the selected pricing check has a report. */
export function OverviewProgressSection({
  lines,
  progress,
}: {
  lines: readonly SummaryLine[];
  progress: AnalysisProgress | null;
}): SafeHtml {
  const total = progress !== null && progress.total > 0 ? progress.total : lines.length;
  const done = progress?.done ?? 0;
  return (
    <List className="overview-progress-section" gap="m">
      <EmptyState
        busy
        title="Running the Pricing Check…"
        detail={total > 0 ? `${String(done)} of ${String(total)} lines benchmarked` : 'Benchmarking each line.'}
      />
      {progress !== null && progress.lines.length > 0 ? (
        <ValueTable label="Lines Benchmarked So Far">
          {progress.lines.map((lineVerdict) => (
            <ValueTableRow
              label={lines.find((line) => line.id === lineVerdict.lineItemId)?.description ?? 'Line item'}
              value={<VerdictChip verdict={lineVerdict.verdict} />}
            />
          ))}
        </ValueTable>
      ) : null}
    </List>
  );
}
